import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter, Inject,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { IHistoryActionButton, IHistoryColumnData } from '../../interfaces/history.interface';
import { IRevision } from '../../../core/interfaces/workflow.interface';
import { DateHandler } from '../../utils/DateHandler';
import { DOCUMENT } from '@angular/common';
import { cloneDeep, isEmpty } from "lodash";

@Component({
  selector: 'gen-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryComponent implements OnInit {
  @ViewChild('panel', {static: false}) panel: ElementRef;
  @ViewChild('toggle', {static: false}) toggle: ElementRef;
  @Output() historyRowClick: EventEmitter<{ revisionId: string, revisionData: any}> = new EventEmitter();
  @Input() actions: IHistoryActionButton[] = [];
  @Input() itemTypeText: string = 'item';
  @Input() dropdownTitle: string = 'Other revisions';
  @Input() columnsToDisplay: Array<IHistoryColumnData> = [];
  @Input() currentRevisionId: string;
  @Input() maxNumberOfDisplayedRows: number;
  private panelState: boolean = false;
  public itemsCount: number = 0;
  private _historyData: Array<{ revision: IRevision, item: { [prop: string]: any}}>;
  private historyDataFormalize: Array<{ revision: IRevision, item: { [prop: string]: any}}>;

   @Input() set historyData(data: Array<{ revision: IRevision, item: { [prop: string]: any}}>) {
    if (data) {
      this._historyData = cloneDeep(data);
      this.itemsCount = this.historyData.length;
      this.historyDataFormalize = this.historyData.sort((a: any, b: any) => this.sortItemsByNewer(a, b));
    }
  }

  @Input() set revisionLastUpdatedDate(data) {
    if (!isEmpty(data) && !isEmpty(this._historyData)) {
     this._historyData.forEach(rev => {
       if (data[rev.revision.id]) {
         rev.revision.meta.lastUpdated = data[rev.revision.id];
       }
     });
    }
  }

  get historyData() {
    return this._historyData;
  }

  constructor() { }

  ngOnInit() { }

  sortItemsByNewer(a: any, b: any) {
    let aDate: string;
    let bDate: string;

    if (a.revision.meta.lastUpdated) {
      aDate = a.revision.meta.lastUpdated;
    } else {
      aDate = a.revision.meta.created;
    }
    if (b.revision.meta.lastUpdated) {
      bDate = b.revision.meta.lastUpdated;
    } else {
      bDate = b.revision.meta.created;
    }
    return DateHandler.getTime(new Date(bDate)) - DateHandler.getTime(new Date(aDate));
  }

  togglePanel(event, state: boolean) {
    if (event && (event.target == this.toggle.nativeElement || event.target.parentElement == this.toggle.nativeElement) && state != undefined) {
      return;
    }

    this.panelState = state != undefined ? state : !this.panelState;
  }

  rowClick(historyItem: any) {
    this.historyRowClick.emit({ revisionId: historyItem.revision.id, revisionData: historyItem});
    this.togglePanel(null, false);
  }

  positionPanel(reAppend: boolean) {
    // todo: fix design issue, until then this is empty function
    return;
  //   let panel = this.panel.nativeElement;
  //   let top = this.toggle.nativeElement.getBoundingClientRect().bottom;
  //   let right = this.toggle.nativeElement.getBoundingClientRect().right;
  //   panel.setAttribute("style", `top:${top}px;right: calc(100vw - ${right}px);`);
  //   if (reAppend)
  //     this.document.body.appendChild(panel);
  }
}

